import { ReactElement, useRef } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import { manageCardHoldersModalContainerId } from 'const/modalContainerId'
import i18n from 'strings/i18n'
import {
  ModalHeader,
  SlideInModalPortal
} from 'syf-component-library/ui/patterns/SlideInModalPortal'

import {
  AuthenticationRedirectProps,
  handleMFEAuthenticationRedirect
} from 'helpers/authenticationRedirect'
import routes from 'const/routes'
import { ManageCardHolders } from 'account-services-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'

const ManageCardholderModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const headerRef = useRef(null)
  const selectedAccount = useAtomValue(selectedAccountAtom)

  const mfeConfig = getMFEConfig('mfe')

  const containerId = manageCardHoldersModalContainerId(selectedAccount)
  const parentElement = document.getElementById(containerId)

  const handleCloseModal = () => {
    updateModalStatus('')
  }

  const handleEscapeAndModalHeader = () => {
    triggerAnalyticsEvent({
      pageFunction: 'account services',
      pageKind: 'account services'
    })
    handleCloseModal()
  }

  const handleAuthFlow = () => {
    const props: AuthenticationRedirectProps = {
      navigateTo: routes.ACCOUNT_SERVICES,
      modal: 'ManageCardholders',
      scope: 'read write write:sensitive'
    }

    handleMFEAuthenticationRedirect(props)
  }

  return (
    modalId === 'ManageCardholders' &&
    parentElement && (
      <SlideInModalPortal
        containerId={containerId}
        escapeModalHandler={handleEscapeAndModalHeader}
        id={`mch-slide-in-modal-${selectedAccount}`}
        isOpen={modalId === 'ManageCardholders'}
        modalTriggerId={modalTriggerId}
        header={
          <ModalHeader
            closeModal={handleEscapeAndModalHeader}
            content={i18n({ button: 'manageCardholders' }) as string}
            data-test="mch-modal-header"
            dataType="x button"
            headerRef={headerRef}
          />
        }
      >
        <ManageCardHolders
          authenticationRedirect={handleAuthFlow}
          config={mfeConfig}
          handleClose={handleCloseModal}
          selectedAccountId={selectedAccount}
        />
      </SlideInModalPortal>
    )
  )
}

export default ManageCardholderModal
